import * as types from './constants';

// Sendbird Token
export const getSendbirdTokenRequest = data => (
  { type: types.GET_SENDBIRD_TOKEN_REQUEST, payload: data }
);

export const getSendbirdTokenDone = data => (
  { type: types.GET_SENDBIRD_TOKEN_DONE, payload: data }
);

export const getSendbirdTokenFailed = errors => (
  { type: types.GET_SENDBIRD_TOKEN_FAILED, payload: errors }
);